import { CloseButton } from "@chakra-ui/react";

export default function LaunchdeckCloseButton({handleCloseModal, hide, onClick, bg, color}) {
	if (hide) return null;

	return (
		<CloseButton cursor='pointer' fontSize='0.7em' boxSize='2.5em' color={color || 'gray.400'} bg={bg && bg} rounded='50%' onClick={handleCloseModal || onClick} />
	)
}
